import { useTranslation } from 'react-i18next';

export default function useTranslateErrorMessage() {
  const { t } = useTranslation(['system']);

  const translateMessage = (code) => {
    const exp = /\[([^\]]+)]/;

    // Check if message displayed should include a specific attribute
    const givenField = code?.match(exp);

    if (givenField) {
      const isolatedCode = code.substr(code.indexOf(' ') + 1);
      return `El parámetro "${givenField[1]}" ${t(isolatedCode)}`;
    }

    return t(code);
  };

  return { translateMessage };
}
